export default "__VITE_ASSET__LMFQ5uCp__"